// extracted by mini-css-extract-plugin
export default {"container":"artwork-rejected_container__rgSrC"};